import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as resource from '../constants/Resources'
import { getTranslation } from '../actions/dataActions'

class OrderLineListItem extends Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap() {

    }

    render() {
        return (
            <div >
                {this.props.show &&
                    <table className="orderDetails">
                        <tr>
                            <th> {this.props.getTranslation(resource.ARTICLE)} </th>
                            <th id="numberTH"> {this.props.getTranslation(resource.PRICE)} </th>            
                            <th> {this.props.getTranslation(resource.QUANTITY)} </th>     
                            <th id="numberTH"> {this.props.getTranslation(resource.SUB_TOTAL)} </th>


                        </tr>
                        {this.props.OrderLines.map(line =>
                            <tr key={line.LineNumber}>
                                <td>{line.ArticleDescription}</td>
                                <td id="numberTD"> {line.Price.toFixed(2)}</td>
                                <td> {line.Quantity}</td>
                                <td id="numberTD"> {(line.Price * line.Quantity).toFixed(2)} </td>
                            </tr>                          
                        )}
                    </table>
                }
            </div>
        )
    }
}

OrderLineListItem.propTypes = {
    Callback: PropTypes.func
}
function mapStateToProps() {
    return {

    }
}

export default connect(mapStateToProps, {
    getTranslation
})(OrderLineListItem)


// WEBPACK FOOTER //
// src/components/OrderLineListItem.jsx